import React from "react";
import { observer, inject } from "mobx-react";
import { CompareLayout } from "ComponentsUI/Compare";
import isEmpty from "lodash/isEmpty";
import ceil from "lodash/ceil";
import { generateUrl } from "Services/withDefaultParams";
import { withRouter } from "react-router-dom";
var Routes = require("Configs/routes");
import Metrika from "Services/Metrika";
import { CLICK_CONNECT_TARIFF } from "Constants/metriks/Yandex";

@withRouter
@inject("ApplicationModel")
@observer
export default class CompareTariffications extends React.Component {
	onChangeUrl(tariff) {
		let {
			ApplicationModel: { tariffsModel },
		} = this.props;
		tariffsModel.setTariff(tariff);
		if (tariff.provider.vip_provider == 1) {
			let orderToHomeUrl = generateUrl(Routes.OrderHome.route, {
				regionUrl: this.props.match.params.regionUrl,
			});
			this.props.history.push({
				pathname: orderToHomeUrl,
			});
		} else {
			let addressUrl = generateUrl(Routes.AddressDistricts.route, {
				regionUrl: this.props.match.params.regionUrl,
			});
			this.props.history.push({
				pathname: addressUrl,
			});
		}
	}

	componentWillUnmount() {
		let {
			ApplicationModel: { compareTarifficationsModel },
		} = this.props;
		compareTarifficationsModel.resetRestoreCompare();
	}

	hasInternet(item) {
		return item.hasOwnProperty("internet") && item.internet !== null;
	}

	render() {
		let {
			ApplicationModel: { compareTarifficationsModel, text, windowSizeModel },
		} = this.props;
		let tariffs = compareTarifficationsModel.getTariffs();
		let maxSpeedTariffObj = {};
		let maxSpeedTariff = 0;
		let speedPrev = 0;
		let speedNext = 0;
		let counter = 0;
		if (!isEmpty(tariffs)) {
			maxSpeedTariffObj = tariffs.reduce((prev, next) => {
				speedNext = 0;
				if (this.hasInternet(prev)) {
					speedPrev = prev.internet.speed_in;
				}

				if (this.hasInternet(next)) {
					speedNext = next.internet.speed_in;
				}

				return speedPrev > speedNext ? prev : next;
			});
			tariffs.forEach((item, index) => {
				if (this.hasInternet(item)) {
					if (item.internet.speed_in == maxSpeedTariffObj.internet.speed_in) {
						counter++;
					}
				}
			});
		}

		if (this.hasInternet(maxSpeedTariffObj)) {
			maxSpeedTariff = counter !== tariffs.length ? maxSpeedTariffObj.internet.speed_in : -1;
		}
		let maxChannelsTvTariff = 0;
		counter = 0;
		if (!isEmpty(tariffs)) {
			maxChannelsTvTariff = tariffs.reduce((prev, next) => {
				if (!isEmpty(prev.tv) && !isEmpty(next.tv)) {
					return prev.tv.channels > next.tv.channels ? prev : next;
				} else if (!isEmpty(prev.tv) && isEmpty(next.tv)) {
					return prev;
				} else {
					return next;
				}
			});
			tariffs.forEach((item) => {
				if (item.tv && item.tv.channels == maxChannelsTvTariff.tv.channels) {
					counter++;
				}
			});
			maxChannelsTvTariff = counter != tariffs.length ? maxChannelsTvTariff : null;
		}

		let minCostTariffObj = {};
		let minCostTariff = 0;
		let minCostPrev = 0;
		let minCostNext = 0;
		counter = 0;
		if (!isEmpty(tariffs)) {
			minCostTariffObj = tariffs.reduce((prev, next) => {
				if (prev.hasOwnProperty("displayPrice")) {
					minCostPrev = prev.displayPrice;
				}

				if (next.hasOwnProperty("displayPrice")) {
					minCostNext = next.displayPrice;
				}
				return minCostPrev < minCostNext ? prev : next;
			});
		}
		if (minCostTariffObj.displayPrice) {
			minCostTariff = minCostTariffObj.displayPrice;
		}

		if (!isEmpty(tariffs)) {
			tariffs.forEach((item) => {
				if (item.displayPrice && item.displayPrice == minCostTariff) {
					counter++;
				}
			});

			minCostTariff = counter != tariffs.length ? minCostTariff : null;
		}

		let minSingleMBOTariffObj = {};
		let minSingleMBOTariff = 0;
		let speedPrevSingleMBO = 0;
		let speedNextSingleMBO = 0;
		let pricePrev = 0;
		let priceNext = 0;
		let singleMBOPrev = 0;
		let singleMBONext = 0;
		if (!isEmpty(tariffs)) {
			minSingleMBOTariffObj = tariffs.reduce((prev, next) => {
				speedPrevSingleMBO = 0;
				speedNextSingleMBO = 0;
				pricePrev = 0;
				priceNext = 0;
				singleMBOPrev = 0;
				singleMBONext = 0;
				if (prev) {
					if (this.hasInternet(prev)) {
						speedPrevSingleMBO = prev.internet.speed_in;
					}
				}
				if (next) {
					if (this.hasInternet(next)) {
						speedNextSingleMBO = next.internet.speed_in;
					}
				}

				if (prev) {
					if (prev.hasOwnProperty("displayPrice")) {
						pricePrev = prev.displayPrice;
					}
				}
				if (next) {
					if (next.hasOwnProperty("displayPrice")) {
						priceNext = next.displayPrice;
					}
				}

				if (speedPrevSingleMBO != 0) {
					singleMBOPrev = ceil(pricePrev / speedPrevSingleMBO, 2);
				}
				if (speedNextSingleMBO != 0) {
					singleMBONext = ceil(priceNext / speedNextSingleMBO, 2);
				}
				if (singleMBOPrev && singleMBONext) {
					return singleMBOPrev < singleMBONext ? prev : next;
				} else if (singleMBOPrev && !singleMBONext) {
					return prev;
				} else if (!singleMBOPrev && singleMBONext) {
					return next;
				}
			}, minSingleMBOTariffObj);
		}

		if (
			!!minSingleMBOTariffObj &&
			minSingleMBOTariffObj.hasOwnProperty("price") &&
			!!minSingleMBOTariffObj.price
		) {
			minSingleMBOTariff = ceil(
				minSingleMBOTariffObj.displayPrice / minSingleMBOTariffObj.internet.speed_in,
				2
			);
		}

		let minConnectionTimeTariffObj = {};
		let minConnectionTimeTariff = 0;
		let minConnectionTimePrev = 0;
		let minConnectionTimeNext = 0;

		if (!isEmpty(tariffs)) {
			minConnectionTimeTariffObj = tariffs.reduce((prev, next) => {
				if (prev) {
					if (prev.hasOwnProperty("connection")) {
						minConnectionTimePrev = prev.connection.time;
					}
				}

				if (next) {
					if (next.hasOwnProperty("connection")) {
						minConnectionTimeNext = next.connection.time;
					}
				}

				return minConnectionTimePrev < minConnectionTimeNext ? prev : next;
			});
		}

		if (minConnectionTimeTariffObj.internet) {
			minConnectionTimeTariff = minConnectionTimeTariffObj.connection.time;
		}

		return (
			<CompareLayout
				compareTariffs={tariffs}
				maxSpeedTariff={maxSpeedTariff}
				maxChannelsTvTariff={maxChannelsTvTariff}
				minCostTariff={minCostTariff}
				minSingleMBOTariff={minSingleMBOTariff}
				minConnectionTimeTariff={minConnectionTimeTariff}
				// linkPrev={linkPrev}
				removeTariff={(tariff) => {
					compareTarifficationsModel.removeTariff(tariff);
				}}
				textConfig={text}
				firstSuggestion={
					tariffs.length == 1
						? text.emptyCompareTariffsFirstSuggestionOneElement
						: text.emptyCompareTariffsFirstSuggestionEmpty
				}
				secondSuggestion={text.emptyCompareTariffsSecondSuggestion}
				onChangeUrl={(item) => this.onChangeUrl(item)}
				windowSizeModel={windowSizeModel}
			/>
		);
	}
}
